import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Category, PurposeType, QuestionVM, ResultType, UserPointsVM } from '../models/avbhakthi.model';
import { MenuService } from '../common/menu.service';
import { MenuCategories } from '../common/menu.model';
import { NewsService } from '../common/news.service';
import { QuestionService } from '../common/question.service';
import { ProfileService } from '../common/profile.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-prasna-vinodhini',
  templateUrl: './prasna-vinodhini.component.html',
  styleUrls: ['./prasna-vinodhini.component.css']
})
export class PrasnaVinodhiniComponent implements OnInit, OnDestroy {

  prasnaVinodhini: QuestionVM[];
  noMoreNews = false;
  contentLoading: boolean = true;

  serviceSubscriptions: Subscription;
  userPoints: UserPointsVM = new UserPointsVM();

  constructor(
    private menuService: MenuService,
    private questionService: QuestionService,
    private profileService: ProfileService
  ) {
    this.serviceSubscriptions = new Subscription();
    this.menuService.setMenuItems(MenuCategories.prasnaVinodini)
    this.prasnaVinodhini = [];
    this.serviceSubscriptions.add(
    this.questionService
      .getQuestions(10, Category.bhakthiNews, PurposeType.forMainScreen, false, ResultType.after)
      .subscribe(data => {
        this.contentLoading = false;
        if (data.length > 0) {
          // this.latestNews = data;
          this.prasnaVinodhini = [...this.prasnaVinodhini, ...data];
        } else {
          this.noMoreNews = true;
        }
      }, error => {
        // console.log(error);
        this.contentLoading = false;
      })
    );
    this.serviceSubscriptions.add(this.profileService.userPoints.subscribe(points => {
      this.userPoints = points;
    }));
  }

  ngOnInit(): void {
  }
  @HostListener("window:scroll", ["$event"])
  onWindowScroll() {

    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight && !this.noMoreNews && !this.contentLoading) {
      // console.log('You have reached bottome of page');
      let lastNewsId = '';
      this.contentLoading = true;
      if (this.prasnaVinodhini.length > 0 && this.prasnaVinodhini.length > 0)
        lastNewsId = this.prasnaVinodhini[this.prasnaVinodhini.length - 1].QUESTION_EXTERNAL_ID;
        this.serviceSubscriptions.add(
      this.questionService
        .getQuestions(10, Category.bhakthiNews, PurposeType.forMainScreen, false, ResultType.after, lastNewsId)
        .subscribe(data => {
          this.contentLoading = false;
          if (data.length > 0) {
            // this.latestNews = data;
            this.prasnaVinodhini = [...this.prasnaVinodhini, ...data];
          } else {
            this.noMoreNews = true;
          }
        }, error => {
          // console.log(error);
          this.contentLoading = false;
        })
        );
    }
  }
  ngOnDestroy() {
    this.serviceSubscriptions.unsubscribe();
  }
}
